import { Article, Video } from '@/services/coin/social'

export const pipeVideo = ({ title, create_time, description, thumbnails, id }: Video): Article => ({
  title,
  id,
  description,
  link: `https://www.youtube.com/watch?v=${id}`,
  pubDate: create_time.replace(' ', 'T') + 'Z',
  thumbnail: thumbnails?.default.url,
  thumbnails,
  source: 'YOUTUBE',
})

export const pipeArticle = (item: Article): Article => ({
  ...item,
  pubDate: item.publication_time?.replace(' ', 'T') + 'Z',
})
